import StudentRIASECData from './StudentRIASECData';

export default StudentRIASECData;
